
import { composeGetTranslation } from '../../../../../../../common/react/utils/translations';

const getTranslation = composeGetTranslation( 'label.statsLeaders.benchmarking.rank.' );

export const BENCHMARKING = Object.freeze( {
    ELITE: {
        KEY: 'ELITE',
        TEXT: getTranslation( 'elite' ),
    },
    ABOVE_AVERAGE: {
        KEY: 'ABOVE_AVERAGE',
        TEXT: getTranslation( 'aboveAverage' ),
    },
    AVERAGE: {
        KEY: 'AVERAGE',
        TEXT: getTranslation( 'average' ),
    },
    BELOW_AVERAGE: {
        KEY: 'BELOW_AVERAGE',
        TEXT: getTranslation( 'belowAverage' )
    },
} );